import { render, staticRenderFns } from "./LoadDocumentsList.vue?vue&type=template&id=92c3edfa"
import script from "./LoadDocumentsList.vue?vue&type=script&lang=js"
export * from "./LoadDocumentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports